import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../lib/utils';

function ClrLoadingState({ message, className }) {
  return (
    <div className={cn('patient-search-loading', className)}>
      <i className="fa fa-spinner spin" aria-hidden="true" />
      {message}
    </div>
  );
}

ClrLoadingState.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
};

ClrLoadingState.defaultProps = {
  message: 'Loading. Please wait...',
};

export default ClrLoadingState;
